import {IOwayoDataModel} from "../model";
import {ISelObInfoProvider} from "../owayoJSViewerWithSelObs";


export class OpenWarenkorbController {
    private readonly model: IOwayoDataModel;
    private readonly saveEntwurf;
    private selObInfoProvider: ISelObInfoProvider;

    public constructor(model:IOwayoDataModel, selObInfoProvider:ISelObInfoProvider, saveEntwurf:()=>Promise<void>) {
        this.saveEntwurf = saveEntwurf;
        this.selObInfoProvider = selObInfoProvider;
        this.model = model;
    }

    public execute() {
        if (this.model.entwurf.needsSaving() && $("#divArtikelView").hasClass("ele-hidden")) {
            this.saveEntwurf().then(()=>OpenWarenkorbController.open(OpenWarenkorbController.getOpenParamsFromModel(this.model)));
        } else {
            OpenWarenkorbController.open(OpenWarenkorbController.getOpenParamsFromModel(this.model));
        }
    }

    private static getOpenParamsFromModel(model:IOwayoDataModel) {
        return {entwurfID:model.entwurf.getID(), sprache:model.getSprache(), land:model.getLand(), kundenKonfi:model.getKundenKonfi(), webSportFuerProduktAuswahlInt:model.getWebSportFuerProduktAuswahlInt()}
    }

    public static getWarenkorbURL(params:{entwurfID, sprache, land, kundenKonfi}) {
        let url = "/shoppingcart/index.php?land="+params.land+"&lang="+params.sprache;
        if (params.kundenKonfi !== ""){
            url = url+"&konfi="+params.kundenKonfi;
        }
        return url;
    }

    public static getWareborbReturnURL(params:{entwurfID, sprache, land, kundenKonfi, webSportFuerProduktAuswahlInt}) {
        let returnURL = window.location.href.split('#')[0].split("?")[0] +"?saveId="+params.entwurfID+"&lang="+params.sprache+"&land="+params.land+"&returnLink=true"+"&sport=" + params.webSportFuerProduktAuswahlInt;
        if(isNaN(params.entwurfID)){
            returnURL = window.location.href.split('#')[0].split("?")[0] +"?lang="+params.sprache+"&land="+params.land+"&returnLink=true"+"&sport=" + params.webSportFuerProduktAuswahlInt;
        }

        if (params.kundenKonfi !== ""){
            returnURL = returnURL+"&konfi="+params.kundenKonfi;
        }
        return returnURL;
    }

    public static setReturnURLInCookie(params:{entwurfID, sprache, land, kundenKonfi, webSportFuerProduktAuswahlInt}) {
        document.cookie = "Shoppingcart_ReturnURL=" + OpenWarenkorbController.getWareborbReturnURL(params) + ";path=/";
    }

    public static open(params:{entwurfID, sprache, land, kundenKonfi, webSportFuerProduktAuswahlInt}){
        OpenWarenkorbController.setReturnURLInCookie(params)
        window.location.href = OpenWarenkorbController.getWarenkorbURL(params);
    }
}
